;globalThis["_sentryRewritesTunnelPath"] = "/api/monitoring-tunnel";globalThis["SENTRY_RELEASE"] = {"id":"ff3fdf8adb24affac67a323a0a36c0594ca974d1"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'
import { ignoredErrors } from '@captaincause/lib/sentry'
import { version } from './version'

const isProduction = process.env.NEXT_PUBLIC_APP_ENV === 'production'

const release = isProduction ? `web@${version}` : undefined

const integrations = []
if (isProduction) {
  integrations.push(Sentry.browserSessionIntegration())
}

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_APP_ENV,
  integrations,
  release,
  replaysOnErrorSampleRate: 0,
  replaysSessionSampleRate: 0,
  beforeSend: event => {
    const shouldIgnore = event.exception?.values?.some(value =>
      ignoredErrors.includes(value?.value ?? ''),
    )

    return shouldIgnore ? null : event
  },
  tracesSampleRate: 0.5,
  debug: !isProduction,
})
